module.exports = __webpack_public_path__ + "img/a1.bf0e367c.png";